import {
    UPDATE_SHOPPING_LIST_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SHOPPING_LIST_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                status: action.updateShoppingListDetails,
            }
        default:
            return state
    }
}